<template lang="pug">
#message-list.box(v-cloak)
  .box-header
    .note
      span ご家族のLINEの使用履歴を確認できます。
  .box-body
    #message-history.d-flex.flex-row.flex-nowrap.align-items-stretch
      // left side list
      .family-list.d-flex.flex-column.family-message-table-component
        // テーブル
        b-table(
          :items="familyItems"
          :fields="familyFields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :filter-included-fields="filterFields"
          :busy="isLoading"
          sticky-header
          no-border-collapse
          table-class="message-table family-message-table"
          show-empty
          :filter-function="filterTable"
          @filtered="onFiltered"
        )
          // ローディング
          template(#table-busy)
            .text-center.table-loading-message
              b-spinner.spinner
              span.message.align-self-center 読込み中...
          // レコード無し
          template(#empty)
            .empty-message
              span 情報がありません
          // フィルター後レコード無し
          template(#emptyfiltered)
            .empty-message
              span 情報がありません

          // セル：家族ユーザー
          template(#cell(familyMessage)="row")
            .family-row(@click="selectFamily(row.item)" :class="{ selected : isSelected(row.item) }")
              .family-header.d-flex.align-items-top
                .name
                  span {{ row.item.familyName }}
                .date
                  span {{ convertDateTime(row.item.familyMessageLatestDate) }}
              .family-body.d-flex.align-items-center
                .information
                  .relation
                    div
                      span {{ row.item.name }}
                      span ・
                      span {{ row.item.familyRelation }}
                  .last-message
                    div {{ row.item.familyLatestMessage }}

        .table-options.d-flex.flex-row.justify-content-end.align-items-center.flex-wrap
          // 検索
          .search-filter.d-flex.mr-1.align-items-center
            b-input-group.search-filter-input-group.mr-1(size="md")
              b-input-group-prepend
                b-input-group-text.search-filter-icon
                  .search-icon
              b-form-input.search-filter-input(v-model="filter.searchWord" type="search" placeholder="検索ワードを入力してください")
            HelpIcon.d-flex.justify-content-end.align-items-center(popoverId="search-filter-help" title="検索項目について")
              template(v-slot:text)
                div 検索項目は以下になります。
                div ・利用者名
                div ・利用者名（ふりがな）
                div ・家族ユーザー名
          // フィルタリング
          span.table-option-text 利用者グループ:
          .filter
            b-form-select(id="filter-input" v-model="filter.id" :options="filterOptions" size="md")
        .table-options.d-flex.flex-row.justify-content-end.align-items-center.flex-wrap.mr-2
          // ページあたりの行数
          span.table-option-text 1ページの行数:
          .per-page
            b-form-select(id="per-page-select" v-model="perPage" :options="pageOptions" size="md" @change="selectPerPage")
          // ページネーション
          .pagenation
            b-pagination.m-0(v-model="currentPage" :total-rows="rows" :per-page="perPage" :disabled="isLoading" align="center"
              @change="selectPage" hide-goto-end-buttons)

      // right side list
      .message-list.d-flex.flex-column.align-items-stretch
        .message-list-title
          div(v-if="selectedFamily.familyName") {{ selectedFamily.familyName }}様の使用状況
        .message-list-body.d-flex.flex-column.align-items-stretch(ref="messageBody")
          .show-more-btn(v-show="showMoreBtn")
            button.btn(type="button" @click="addMessages") さらに表示する
          .message(v-for="message in messages")
            // message
            div(:class="messageAlign(message.sender)")
              // text message
              div(v-if="message.messageType == 'text'")
                .text.pre-line {{ message.functionContents.content }}
                .date {{ convertDateTime(message.datetime) }}

              // image message
              div(v-if="message.messageType == 'image'")
                .image
                  img(:src="message.functionContents.imageURL")
                .date {{ convertDateTime(message.datetime) }}

              // video message
              div(v-if="message.messageType == 'video'")
                .video
                  video(playsinline autoplay muted loop ref="video" :src="message.functionContents.videoURL" type="video/mp4" controls)
                .date {{ convertDateTime(message.datetime) }}

              // old facility message
              div(v-if="message.messageType == 'buttons'")
                .buttons
                  .buttons-image(v-if="message.functionContents.imageURL")
                    img(:src="message.functionContents.imageURL")
                  .title {{ message.functionContents.title }}
                  .contents.pre-line {{ message.functionContents.content }}
                  .link(v-for="link in getLinks(message.functionContents)")
                    a(:href="link.linkUrl") {{ link.linkTitle }}
                .date {{ convertDateTime(message.datetime) }}

              // flex message & familyMessageReply function
              div(v-if="message.messageType == 'flex' && message.functionType == 0 && message.functionContents.flexMessageType == 1")
                .flex.flex-family-message-reply
                  .sub-title {{ _facilityName }}からの返信
                  .text.pre-line(v-text="message.functionContents.content")
                  hr.mt-1.mb-2
                  .notification-text 元のメッセージを確認したい場合、追加の返信をしたい場合は、送信メッセージ履歴をご確認ください。
                  .link
                    a 送信メッセージ履歴

              // flex message & sendMessageReply function
              div(v-if="message.messageType == 'flex' && message.functionType == 0 && message.functionContents.flexMessageType == 6")
                .flex.flex-family-message-reply
                  .sub-title {{ _facilityName }}からの返信
                  .text.pre-line(v-text="message.functionContents.content")
                  hr.mt-1.mb-2
                  .notification-text 元のメッセージを確認したい場合、追加の返信をしたい場合は、受信メッセージ履歴をご確認ください。
                  .link
                    a 受信メッセージ履歴

              // flex message & sendMessage function
              template(v-if="message.messageType == 'flex' && message.functionType == 0")
                div(v-if="(message.functionContents.flexMessageType == 0 || message.functionContents.flexMessageType == undefined)")
                  .flex.flex-send-message
                    .sub-title {{ _facilityName }}からのメッセージ
                    .title.pre-line(v-text="message.functionContents.title")
                    .text
                      template(v-for="content in createSendMessageContents(message.functionContents.content)")
                        .text-content.pre-line(v-if="content.type == 'text'")
                          span {{ content.value }}
                        .link-content.text-center(v-else style="padding: 4px;")
                          a(:href="content.uri" target="_blank") {{ content.value }}
                    .expiration-date.pre-line(v-if="message.functionContents.expirationDate" v-text="message.functionContents.expirationDate")
                    .expiration-text.pre-line(v-if="message.functionContents.expirationText" v-text="message.functionContents.expirationText")
                    .sepalator
                    .send-message-buttons.mb-2
                      .read(v-if="message.functionContents.addReadButton")
                        span 見ました
                      .reply(v-if="message.functionContents.addReplyButton")
                        span 返信
                    .option-text(v-if="message.functionContents.addReplyButton && message.functionContents.replyLimit") 返信可能期限は{{ message.functionContents.replyLimit }}日以内です。
                    .option-text(v-if="message.functionContents.addOptionText") 「見ました」が押されなかった場合、施設から連絡をさせて頂く場合があります。
                  .date {{ convertDateTime(message.datetime) }}

                  // APIの仕様変更対応で、attachedFilesがある場合は添付ファイルを表示する
                  .message(v-for="file in message.functionContents.attachedFiles")
                    // image message
                    div(v-if="file.type == 'image'")
                      .image
                        img(:src="file.url")
                    // video message
                    div(v-if="file.type == 'video'")
                      .video
                        video(playsinline autoplay muted loop ref="video" :src="file.url" type="video/mp4" controls)
                    // pdf message
                    div(v-if="file.type == 'pdf'")
                      .pdf.flex.flex-send-message
                        .title.pre-line 添付ファイル
                        .text.pre-line
                          span PDFの添付ファイルがあります。
                          br
                          span ファイル名：{{ file.name }}
                        .link
                          a(@click="showPdf(file)") PDFファイルを開く
                    // datetime(commons)
                    .date {{ convertDateTime(message.datetime) }}

                // send document
                div(v-else-if="(message.functionContents.flexMessageType == 5)")
                  .flex.flex-send-message
                    .sub-title {{ _facilityName }}からのメッセージ
                    .title.pre-line(v-text="message.functionContents.title")
                    .text.pre-line(v-text="message.functionContents.content")
                    .sepalator
                    .link
                      a 文書確認、同意返信

              // flex message & event function
              div(v-if="message.messageType == 'flex' && message.functionType == 3")
                .flex.flex-event
                  .flex-image(v-if="message.functionContents.imageURL")
                    img(:src="message.functionContents.imageURL")
                  .sub-title {{ _facilityName }}
                  .title(v-if="message.functionContents.title") {{ message.functionContents.title }}
                  .flex-option(v-if="message.functionContents.date")
                    span 日付
                    | {{ message.functionContents.date }}
                  .flex-option(v-if="message.functionContents.time")
                    span 時間
                    | {{ message.functionContents.time }}
                  .flex-option(v-if="message.functionContents.place")
                    span 場所
                    | {{ message.functionContents.place }}
                  .flex-option(v-if="message.functionContents.holdType")
                    span 開催
                    | {{ message.functionContents.holdType }}
                  .flex-option(v-if="message.functionContents.replyDeadline")
                    span 申込
                    | {{ message.functionContents.replyDeadline }}
                  hr.mt-1.mb-2
                  .contents.pre-line(v-if="message.functionContents.content") {{ message.functionContents.content }}
                .date {{ convertDateTime(message.datetime) }}

              // flex message & facility function
              div(v-if="message.messageType == 'flex' && message.functionType == 5")
                .buttons
                  .buttons-image(v-if="message.functionContents.imageURL")
                    img(:src="message.functionContents.imageURL")
                  .title {{ message.functionContents.title }}
                  .contents.pre-line {{ message.functionContents.content }}
                  .link(v-for="link in getLinks(message.functionContents)")
                    a(:href="link.linkUrl") {{ link.linkTitle }}
                .date {{ convertDateTime(message.datetime) }}

              // flex message & safety confirmation
              div(v-if="message.messageType == 'flex' && message.functionType == 0 && message.functionContents.flexMessageType == 3")
                .flex.flex-send-message
                  .sub-title {{ _facilityName }}からのメッセージ
                  .title.pre-line(v-text="message.functionContents.title")
                  .text.pre-line(v-text="message.functionContents.openingSentence")
                  .sepalator
                  .link
                    a 安否情報はここから

              // flex message & questionnaire
              div(v-if="message.messageType == 'flex' && message.functionType == 0 && message.functionContents.flexMessageType == 9")
                .flex.flex-send-message
                  .sub-title {{ _facilityName }}からのメッセージ
                  .title.pre-line(v-text="message.functionContents.title")
                  .text.pre-line(v-text="message.functionContents.content")
                  .sepalator
                  .link
                    a アンケートの回答はここから

              // confirm message
              div(v-if="message.messageType == 'confirm'")
                .buttons
                  .contents.pre-line {{ message.functionContents.content }}
                  .d-flex.flex-row.justify-content-center
                    .link(v-for="link in getLinks(message.functionContents)").flex-grow-1
                      a(:href="link.linkUrl") {{ link.linkTitle }}
                .date {{ convertDateTime(message.datetime) }}
          Loading(ref="messageLoading")
  PdfModal(v-model="showPdfModal" :pdfUrl="pdfUrl")
</template>

<script lang="ts">
import { Component, Inject, Watch, Vue } from "vue-property-decorator";
import { Route } from "vue-router";
import { userStore, itemListFilterStore } from "@/store/store";
import { errorHandle } from "@/errorHandler";

import Setting from "../../../../public/setting.json";
import SystemError from "@/commons/models/SystemError";
import FamiliesService, { FamilyGetModel } from "@/commons/services/Families";
import FamilyModel, { SenderType } from "@/commons/models/Resident";
import MessagesInFamilyService from "@/commons/services/MessagesInFamily";
import MessageModel from "@/commons/models/Message";
import S3UrlService from "@/commons/services/S3Url";
import ResidentGroupsService, { ResidentGroupsGetModel } from "@/commons/services/ResidentGroups";

import Loading from "@/pc/basics/Loading.vue";
import PdfModal from "@/pc/basics/PdfModal.vue";
import HelpIcon from "@/pc/basics/HelpIcon.vue";

/** ナビゲーションガードのフックを使えるようにする */
Component.registerHooks(["beforeRouteLeave"]);

/**
 * 家族の使用状況画面コンポーネント
 */
@Component({
  components: {
    Loading,
    PdfModal,
    HelpIcon
  }
})
export default class MessageList extends Vue {
  /** 家族サービス */
  @Inject("FamiliesService") familiesService!: FamiliesService;
  /** 家族メッセージサービス */
  @Inject("MessagesInFamilyService") messagesInFamilyService!: MessagesInFamilyService;
  /** S3Urlサービス */
  @Inject("S3UrlService") s3UrlService!: S3UrlService;
  /** 利用者グループサービス */
  @Inject("ResidentGroupsService") residentGroupsService!: ResidentGroupsService;

  /** 1行あたりの情報配列 */
  familyItems: Array<MessageTableItem> = [];
  /** 列名配列 */
  familyFields: Array<MessageField> = [];
  /** 選択されている家族 */
  selectedFamily: FamilyGetModel | any = {};
  /** 選択されている家族のメッセージ */
  messages: Array<MessageModel> = [];

  /** フィルタリング条件 */
  filter: { searchWord: string; id: string } = { searchWord: "", id: "" };
  /** フィルター選択項目 */
  filterOptions: Array<{ value: string; text: string }> = [];
  /** フィルタリング対象カラム名 */
  filterFields: string[] = ["groupId"];
  /** 現在のページ */
  currentPage: number = 1;
  /** 現在取得している件数 */
  currentRows: number = 0;
  /** ページングの全体行数 */
  rows: number = 0;
  /** 1ページあたりの表示行数 */
  perPage: number = Number(Setting.message.perPage);
  /** 1ページに表示する行数の選択項目 */
  pageOptions: number[] = Setting.message.pageOptions;
  /** 先行して取得するページ範囲 */
  pageRange: number = Setting.message.pageRange;
  /** ローディング表示可否 */
  isLoading: boolean = false;

  /** メッセージの1リクエストあたりの取得数 */
  messageRequestCount: number = Number(Setting.message.messageRequestCount);
  /** メッセージ取得時に使用する、取得範囲終了日時 */
  messageEndTime: number = 0;
  /** メッセージに対して「さらに表示する」ボタンを表示するか否か */
  showMoreBtn: boolean = false;

  /** PDFモーダルの表示可否 */
  showPdfModal: boolean = false;
  /** PDFモーダルで表示するPDFのURL */
  pdfUrl: string = "";

  get _facilityName(): string {
    if (!userStore.facility) {
      return "施設名未登録";
    }

    return userStore.facility.name ? userStore.facility.name : "施設名未登録";
  }

  /**
   * ### 1ページあたりの表示行数の変更イベント
   *
   * - 変更をクッキーに持たせる
   */
  @Watch("perPage")
  public changePerPage(perPage: number): void {
    this.setCookie(perPage);

    return;
  }

  /**
   * ### 1ページあたりの表示行数をCookieに設定する
   */
  public setCookie(perPage: number): void {
    // Cookie有効秒数。有効期限は必ず設定しないといけないので、10年分にしておく
    const saveSecond = 10 * 365 * 24 * 60 * 60;
    document.cookie = `message-list-per-page=${perPage}; max-age=${saveSecond};`;

    return;
  }

  /**
   * Vue Lifecycle mounted
   */
  public async mounted(): Promise<void> {
    // 画面初期表示時に作成して変更しないものを初期化する
    const fields: Array<MessageField> = this.createFields();
    this.familyFields = fields;
    // 1ページあたりの表示行数はCookieから取得する。取得できない場合はデフォルト値を使用する
    const perPage: number | null = this.loadCookie();
    this.perPage = perPage ? perPage : Number(Setting.opinion.perPage);
    // フィルタの復元
    this.restoreFilterSetting();

    const groups: Array<ResidentGroupsGetModel> = await this.getResidentGroups();
    const filterOptions: Array<{ value: string; text: string }> = await this.createFilterOptions(groups);
    this.filterOptions = filterOptions;

    // 動的に変更する画面情報を作成する
    this.familyItems = [];
    this.currentRows = this.familyItems.length;
    this.currentPage = 1;

    await this.createView();

    return;
  }

  /**
   * ### 家族ユーザーの列名を作成する
   */
  public createFields(): Array<MessageField> {
    let fields: Array<MessageField> = [];

    fields.push({ key: "familyMessage", label: "家族ユーザー", sortable: false, sortDirection: "desc", class: "family-message" });

    return fields;
  }

  /**
   * ### Cookieを見て、値が保持されている場合はCookieの値を返す
   */
  public loadCookie(): number | null {
    if (document.cookie) {
      let cookieMap: any = {};
      let cookies: Array<string> = document.cookie.split("; ");
      cookies.forEach(function (value) {
        //cookie名と値に分ける
        let content = value.split("=");
        cookieMap[content[0]] = content[1];
      });

      // cookieに値が格納されていないとundefinedが格納されているが、実際にはゴミデータが格納されているのでisNaN()でチェックが必要
      const perPage: number = cookieMap["message-list-per-page"];

      return isNaN(perPage) ? null : perPage;
    }

    return null;
  }

  /** フィルタ情報がstoreに存在する場合は復元する */
  private restoreFilterSetting(): void {
    if (this.$options.name && itemListFilterStore.filterMap[this.$options.name] != undefined) {
      this.filter = itemListFilterStore.filterMap[this.$options.name];
    }
    return;
  }

  /**
   * ### 全ての利用者グループを取得する
   */
  public async getResidentGroups(): Promise<Array<ResidentGroupsGetModel>> {
    const response: Array<ResidentGroupsGetModel> = await this.residentGroupsService.gets(userStore);
    return response;
  }

  /**
   * ### 利用者グループフィルター用選択項目
   *
   * - 検索用に利用者グループマスターのMAPを作る
   * - アカウント情報から許可されている利用者グループIDの配列を取得する
   * - 利用者グループマスターと照合して選択項目の利用者グループを作成する
   */
  public createFilterOptions(residentGroups: Array<ResidentGroupsGetModel>): Array<{ value: string; text: string }> {
    const filterOptions: Array<{ value: string; text: string }> = [];

    filterOptions.push({
      value: "",
      text: "全て"
    });

    const allowedGroupsMap: Map<number, number> = new Map<number, number>();
    for (const allowedGroup of userStore.loginUser.permissions.residentGroups) {
      allowedGroupsMap.set(allowedGroup, allowedGroup);
    }
    for (const group of residentGroups) {
      if (allowedGroupsMap.has(group.id)) {
        filterOptions.push({
          value: `${group.id}`,
          text: group.name
        });
      }
    }

    return filterOptions;
  }

  /**
   * ### 画面表示情報を作成する
   */
  public async createView(): Promise<void> {
    this.isLoading = true;

    // 全体の行数を非同期で取得する
    this.setRows();

    // ご意見テーブルに渡す各プロパティを作成する
    const families: Array<FamilyGetModel> = await this.getFamilies();
    const items: Array<MessageTableItem> = this.createItems(families);
    this.familyItems = this.familyItems.concat(items);
    this.currentRows = this.familyItems.length;

    this.isLoading = false;

    return;
  }

  /**
   * ### ページング用の全件数を設定する
   */
  public async setRows() {
    try {
      const params: any = {
        senderType: SenderType.LINE
      };
      const count: number = await this.familiesService.getCountInFacility(userStore, params);
      this.rows = count;
    } catch (error) {
      // 本処理はawaitされない非同期処理なので、共通エラーハンドラーが例外をキャッチしない
      // 例外発生時は自分でエラーハンドラーを呼ぶ
      errorHandle(error, this);
    }

    return;
  }

  /**
   * ### 家族を取得する
   */
  public async getFamilies(): Promise<Array<FamilyGetModel>> {
    let response: Array<FamilyGetModel> = [];

    try {
      const params: any = {
        sortKey: "familyMessageLatestDate",
        order: "desc",
        senderType: SenderType.LINE
      };
      response = await this.familiesService.getsInFacility(userStore, params);
    } catch (error) {
      const systemerror: SystemError = error as SystemError;
      // 413エラーの場合、全件取得した結果がペイロード制限に引っかかったことになるので、index指定で段階的に取得する
      if (systemerror.statusCode == 413) {
        const count: number = await this.familiesService.getCountInFacility(userStore);
        const loopEnd: number = Math.ceil(count / 300);

        for (let i = 0; i < loopEnd; i++) {
          const params: any = {
            startIndex: i * 300,
            endIndex: i * 300 + 300,
            sortKey: "familyMessageLatestDate",
            order: "desc",
            senderType: SenderType.LINE
          };
          response = response.concat(await this.familiesService.getsInFacility(userStore, params));
        }
      }
    }

    return response;
  }

  /**
   * ### 家族ユーザーの行を作成する
   */
  public createItems(families: Array<FamilyGetModel>): Array<MessageTableItem> {
    let items: Array<MessageTableItem> = [];

    for (const family of families) {
      items.push({
        residentsSortKey: family.residentsSortKey,
        id: family.id,
        name: family.name,
        kanaName: family.kanaName,
        groupId: family.groupId,
        familyId: family.familyId,
        familyName: family.familyName,
        familyRelation: family.familyRelation,
        familyMessageLatestDate: family.familyMessageLatestDate,
        familyLatestMessage: family.familyLatestMessage,
        familyLineId: family.familyLineId ? family.familyLineId : ""
      });
    }

    return items;
  }

  /**
   * ### 1ページあたりの表示行数変更イベント
   *
   * - 1ページあたりの表示行数を更新
   * - ページあたりの表示行数が変わるので表の情報を作り直す
   */
  public async selectPerPage(perPage: number): Promise<void> {
    this.perPage = perPage;
    this.currentPage = 1;
    this.familyItems = [];
    this.currentRows = this.familyItems.length;

    this.messages = [];
    this.selectedFamily = {};
    this.showMoreBtn = false;

    await this.createView();

    return;
  }

  /**
   * ### ページネーションのページ番号押下
   */
  public async selectPage(page: number): Promise<void> {
    this.currentPage = page;

    this.messages = [];
    this.selectedFamily = {};
    this.showMoreBtn = false;

    // 初期表示時点では一定数しか情報を取得していないので、既に情報が取得されていなければ取得する
    const newPageRows = this.perPage * (this.currentPage - 1);
    if (this.currentRows <= newPageRows) {
      await this.createView();
    }

    return;
  }

  /**
   * ### フィルタリング
   */
  public filterTable(row: MessageTableItem, filter: { searchWord: string; id: string }): boolean {
    return this.filterGroupId(row, filter) && this.filterSearchWords(row, filter);
  }

  public filterGroupId(row: MessageTableItem, filter: { searchWord: string; id: string }): boolean {
    if (filter.id == "") {
      return true;
    }

    if (row.groupId == Number(filter.id)) {
      return true;
    } else {
      return false;
    }
  }

  public filterSearchWords(row: MessageTableItem, filter: { searchWord: string; id: string }): boolean {
    if (filter.searchWord == "") {
      return true;
    }

    const words: string[] = this.$filterUtil.createSearchWord(filter.searchWord);

    let foundResidentName: boolean = true;
    let foundResidentKanaName: boolean = true;
    let foundFamilyName: boolean = true;

    for (const word of words) {
      // 利用者名
      if (row.name.indexOf(word) == -1) {
        foundResidentName = false;
      }

      // ふりがなが登録されている場合は文字列を含むかチェックする
      if (row.kanaName) {
        if (row.kanaName.indexOf(word) == -1) {
          foundResidentKanaName = false;
        }
      }
      // ふりがなが登録されていない場合は対象外として扱う
      else {
        foundResidentKanaName = false;
      }

      // 家族名
      if (row.familyName.indexOf(word) == -1) {
        foundFamilyName = false;
      }
    }

    return foundResidentName || foundResidentKanaName || foundFamilyName;
  }

  /**
   * ### フィルタリングイベント
   */
  public onFiltered(filteredItems: any) {
    this.rows = filteredItems.length;

    this.messages = [];
    this.selectedFamily = {};
    this.showMoreBtn = false;

    return;
  }

  /**
   * 画面で選択した家族のメッセージを表示
   */
  public async selectFamily(family: MessageTableItem): Promise<void> {
    // 選択した家族が表示中の家族であれば何もしない
    if (this.selectedFamily.residentsSortKey == family.residentsSortKey) {
      return;
    }

    // メッセージを初期化する
    const messageLoading: any = this.$refs.messageLoading;
    messageLoading.show();
    this.messages = [];
    this.showMoreBtn = false;

    // 選択されている家族を更新
    this.selectedFamily = family;

    // メッセージ表示中に家族がメッセージを送ってくる可能性がある
    // そのため終了日時を指定してメッセージ取得用のクエリパラメータを作成する
    const end: number = this.$dateUtil.convertDateToNumber(new Date(), "yyyymmddhhMMss000");
    const params: any = this.createGetMessagesParam(end, 0, this.messageRequestCount);

    // メッセージ取得中に家族が選択されることがありえる
    // そのため、メッセージを取得するが選択中の家族以外のメッセージであれば無視する
    const messages: Array<MessageModel> = await this.createMessages(family, params);

    if (0 < messages.length && messages[0].lineId == this.selectedFamily.familyLineId) {
      this.messages = messages;
      // 「更に表示する」で追加取得する可能性があるので、終了日時は保持する
      this.messageEndTime = end;

      // メッセージを追加で取得できるか確認する
      // 追加で取得できる場合はメッセージの先頭に「さらに表示」ボタンを表示する
      this.showMoreBtn = await this.needShowMore(family);

      // LINE風にするため、スクロール位置を最下段に移動させる
      // 共通のディレクティブを使いたいが、「さらに表示」の場合は最下段に移動してはいけないので自前で実施する
      Vue.nextTick(() => {
        const scrollArea: any = this.$refs.messageBody;
        if (scrollArea && scrollArea.scrollHeight) {
          scrollArea.scrollTop = scrollArea.scrollHeight;
        }
      });
    }
    // 画面遷移でコンポーネントが存在しないタイミングがあるため、存在可否をチェックしてからローディングを非表示にする
    if (messageLoading) {
      messageLoading.hide();
    }

    return;
  }

  /**
   * メッセージ取得用のクエリパラメータを作成する
   */
  private createGetMessagesParam(end: number, startIndex: number, endIndex: number): any {
    const params: any = {
      end: end,
      startIndex: startIndex,
      endIndex: endIndex,
      // 無限スクロールがあるので、取得する情報はレコードの新しい順で取得する
      order: "desc"
    };

    return params;
  }

  /**
   * 画面表示用のメッセージを作成する
   */
  private async createMessages(family: MessageTableItem, params: any): Promise<Array<MessageModel>> {
    let messages: Array<MessageModel> = await this.messagesInFamilyService.get(userStore, family.id, family.familyId ? family.familyId : 0, params);

    // S3の画像URLが渡された場合は変換が必要なので変換する
    for (let message of messages) {
      if (message.functionContents.imageURL) {
        const imageUrl: string = await this.convertS3Url(message.functionContents.imageURL);
        message.functionContents.imageURL = imageUrl;
      }
      if (message.functionContents.videoURL) {
        const videoURL: string = await this.convertS3Url(message.functionContents.videoURL);
        message.functionContents.videoURL = videoURL;
      }
      await this.convertSendMessagesTempFiles(message);
    }

    // 無限スクロールかつ、メッセージは新しいものから取得してきたい
    // そのため取得されてくる情報は降順だが、画面表示は昇順に表示する必要があるため、ここでソートする
    messages = this.sortMessages(messages);

    return messages;
  }

  /**
   * ### メッセージ送信添付ファイルURL変換
   *
   * - APIの仕様変更により、functionContentsの中に添付ファイルが格納されるようになった
   * - 添付ファイルがある場合はそのURLを変換する
   */
  public async convertSendMessagesTempFiles(message: MessageModel): Promise<void> {
    if (message.functionContents.attachedFiles) {
      const files: Array<{ type: string; url: string }> = message.functionContents.attachedFiles;
      for (const file of files) {
        if (file.url) {
          const convertedUrl: string = await this.convertS3Url(file.url);
          file.url = convertedUrl;
        }
        // URLが存在しないことはあり得ないのでシステムエラー
        else {
          const _message: any = message;
          throw new SystemError("attachedFiles.type is invalid. message.sortKey = " + _message.messagesSortKey);
        }
      }
    }

    return;
  }

  /**
   * メッセージを日付昇順でソートする
   */
  private sortMessages(messages: Array<MessageModel>): Array<MessageModel> {
    // 日付でソート
    const sortedMessages: Array<MessageModel> = messages.concat().sort((message1, message2) => {
      if (message1.datetime < message2.datetime) {
        return -1;
      }
      if (message1.datetime > message2.datetime) {
        return 1;
      }
      return 0;
    });

    return sortedMessages;
  }

  /**
   * LINEメッセージ情報のメッセージ種別から判断して、画面表示用のメッセージを作成する
   */
  private async convertS3Url(url: string): Promise<string> {
    // 画像URLが渡されてきた場合はS3にある画像の公開設定を行ってそのURLを画面で使用する
    let publicUrl: string = "";
    try {
      publicUrl = await this.s3UrlService.get(userStore, Setting.backets.imageExpireHour, url);
    } catch (error) {
      // S3の画像が削除されてしまう場合があり得るためシステムエラーにはしない
      console.error("S3 image not fount");
    }

    return publicUrl;
  }

  /**
   * さらに表示するボタンの表示可否を返す
   * 家族のメッセージの全体件数を取得して、取得済みのメッセージ数と比較して判断する
   */
  private async needShowMore(family: MessageTableItem): Promise<boolean> {
    let needShowMore: boolean = false;

    let count: number = await this.messagesInFamilyService.getCount(userStore, family.id, family.familyId ? family.familyId : 0);

    if (this.messages.length < count) {
      needShowMore = true;
    }

    return needShowMore;
  }

  /**
   * メッセージを追加する
   */
  private async addMessages(): Promise<void> {
    // 現在のメッセージ数＋1リクエストあたりの取得数分を取得する
    const startIndex: number = this.messages.length;
    const endIndex: number = this.messages.length + this.messageRequestCount;
    const params: any = this.createGetMessagesParam(this.messageEndTime, startIndex, endIndex);

    // メッセージ取得中に家族が選択されることがありえる
    // そのため、メッセージを取得するが選択中の家族以外のメッセージであれば無視する
    const messages: Array<MessageModel> = await this.createMessages(this.selectedFamily, params);
    if (0 < messages.length && messages[0].lineId == this.selectedFamily.familyLineId) {
      // スクロール位置を調整したいので、現時点のスクロール位置を保持する
      let scrollArea: any = this.$refs.messageBody;
      const scrollHeight: number = scrollArea.scrollHeight;

      // 時系列順に並べたいので、取得したメッセージは現在のメッセージの前に追加する
      this.messages = messages.concat(this.messages);

      // DOMの描画後、保持していた位置にスクロール位置を戻す
      Vue.nextTick(() => {
        if (scrollArea && scrollArea.scrollHeight) {
          scrollArea.scrollTop = scrollArea.scrollHeight - scrollHeight;
        }
      });

      // メッセージを追加で取得できるか確認する
      // 追加で取得できる場合はメッセージの先頭に「さらに表示」ボタンを表示する
      this.showMoreBtn = await this.needShowMore(this.selectedFamily);
    }
  }

  /**
   * その家族が選択されているかを返す
   */
  private isSelected(family: FamilyModel): boolean {
    if (this.selectedFamily.residentsSortKey == family.residentsSortKey) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * 数値の日付を変換して文字列(yyyy/mm/dd hh:MM)で返す
   */
  private convertDateTime(date: number): string {
    let convertDateTime: string = "";

    // 値が存在する場合のみ変換する
    if (date) {
      convertDateTime = this.$dateUtil.convertNumberToString(date, "yyyy/mm/dd hh:MM");
    }

    return convertDateTime;
  }

  /**
   * ### メッセージ返信期限を返す
   */
  public getReplyLimit(): number {
    return userStore.facility.messageSettings.replyLimit;
  }

  /**
   * メッセージの送信IDに応じてCssClassを返す
   * * 送信IDがbotの時は左寄せになるCssClass
   * * 送信IDがbot以外の時は右寄せになるCssClass
   *
   * @param sender 送信ID
   */
  private messageAlign(sender: string): string {
    if (sender == "bot") {
      return "message-left";
    } else {
      return "message-right";
    }
  }

  /**
   * buttonメッセージの際に、コンテンツからlinkを返す
   *
   * コンテンツのlinkが配列なのか、単一文字列なのか登録側があやふやなので画面側で吸収する
   */
  private getLinks(contents: any): Array<{ linkTitle: string; linkUrl?: string }> {
    let links: Array<{ linkTitle: string; linkUrl?: string }> = [];

    // botのデータ格納不備が怖いので、仕様上はありえないがNullチェックする
    if (!contents.linkTitle) {
      contents.linkTitle = [];
    }
    if (!contents.linkURL) {
      contents.linkURL = [];
    }

    // 配列ならループして返却情報を返し、配列でなければ配列に直して返す
    if (Array.isArray(contents.linkTitle)) {
      for (let i = 0; i < contents.linkTitle.length; i++) {
        links.push(this.createLinkObject(contents.linkTitle[i], contents.linkURL[i]));
      }
    } else {
      links.push(this.createLinkObject(contents.linkTitle, contents.linkURL));
    }

    return links;
  }

  /**
   * linkを画面表示用のオブジェクト形式を作成する
   */
  private createLinkObject(title: string, url: string): { linkTitle: string; linkUrl?: string } {
    return {
      // nullがあり得るので、nullの場合は空文字で補完する
      linkTitle: title ? title : "",
      linkUrl: url ? url : undefined
    };
  }

  /**
   * ### PDFをモーダル表示する
   */
  public showPdf(file: { type: string; url: string }): void {
    this.pdfUrl = file.url;
    this.showPdfModal = true;
    return;
  }

  public createSendMessageContents(content: string): Array<{ type: string; value: string; uri?: string }> {
    // contentが存在しない場合は空配列を返す
    if (!content) {
      return [];
    }

    // template側でlinkボタンとテキストを判別するためにtypeを持たせる
    let contents: Array<{ type: string; value: string; uri?: string }> = [];
    const splitedContent: string[] = content.split("\n");
    let buttonCount: number = 1;

    for (const message of splitedContent) {
      let content: { type: string; value: string; uri?: string };

      // リンクボタンメッセージ(ボタン名指定)
      // 先頭に半角全角スペースがあるだけの場合は無視して扱い、それ以外はテキスト文字列として扱う
      if (message.match(/^\[(.*)\]\((.*)\)$/)) {
        const linkRegex = /\[(.*?)\]\((.*?)\)/g;
        const links: Array<{ name: string; url: string }> = [];
        let match: any;

        while ((match = linkRegex.exec(message)) !== null) {
          const name = match[1] ? match[1] : null;
          const url = match[2] ? match[2] : null;
          links.push({ name, url });
        }

        if (links.length == 1 && links[0].name != null && links[0].url != null) {
          content = {
            type: "link",
            value: `${links[0].name}`,
            uri: links[0].url
          };
          contents.push(content);
        } else {
          content = {
            type: "text",
            value: message
          };
          contents.push(content);
        }
      }
      // リンクボタンメッセージ(ボタン名指定無し)
      // 先頭に半角全角スペースがあるだけの場合はURLとして扱い、それ以外はテキスト文字列として扱う
      else if (message.match(/^\s*(http|https):\/\/.+/)) {
        // 前後の半角全角スペースを取り除き、URLデコード&エンコードを考慮したURIを作成する
        const uri: string = message.replace(/^\s+|\s+$/g, "");
        const decodedUri: string = decodeURI(uri);
        const encodedUri: string = encodeURI(decodedUri);

        content = {
          type: "link",
          value: `リンク その${buttonCount}`,
          uri: encodedUri
        };
        buttonCount++;
        contents.push(content);
      }
      // テキストメッセージ
      else {
        const convertedMessage: string = message == "" ? "　" : message;
        content = {
          type: "text",
          value: convertedMessage
        };
        contents.push(content);
      }
    }

    return contents;
  }

  beforeRouteLeave(to: Route, from: Route, next: Function) {
    // 画面を離れる前に現在のフィルタリング条件をVuexに保存
    if (this.$options.name) {
      itemListFilterStore.setFilter({ url: this.$options.name, filter: this.filter });
    }
    next();
  }
}

export interface MessageField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

export interface MessageTableItem {
  residentsSortKey: string;
  id: number;
  name: string;
  kanaName: string;
  groupId: number;
  familyId: number;
  familyName: string;
  familyMessageLatestDate: number;
  familyRelation: string;
  familyLatestMessage: string;
  familyLineId: string;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

// 親要素からネストしてスタイルを指定する
#message-list {
  max-width: 1309px;
  margin-left: auto;
  margin-right: auto;

  @mixin title() {
    background-color: $bg-header;
    padding: 5px;
    min-height: 32px;
    font-weight: bold;
    text-align: center;
  }

  .box {
    margin-bottom: 0;
    // boxの横幅は、中の表のサイズ1269px + 左右余白を最大値とする
    max-width: 1269 + 60px;
  }

  #message-history {
    // デフォルトフォントサイズを指定する
    font-size: 16px;
    // 外枠はここで描画させる
    border: solid 1px $border-darkgray;

    // 左側、家族リスト
    .family-list {
      min-width: 50%;
      max-width: 50%;

      // 意見1行分のスタイル
      .family-row {
        padding: 6px 15px;
        min-height: 75px;
        // リンクであることが分かるようにカーソルを変える
        cursor: pointer;

        &:hover {
          background-color: $list-hover !important;
        }

        .family-header {
          .name {
            width: calc(100% - 134px);
            padding-right: 12px;
            font-weight: bold;
          }
          .date {
            width: 134px;
            font-size: 14px;
            text-align: right;
          }
        }
        .family-body {
          .information {
            .last-message,
            .relation {
              div {
                font-size: 14px;
              }
              .sepalator {
                padding-left: 5px;
                padding-right: 5px;
              }
            }
            .last-message {
              div {
                max-width: calc(14px * 15); // iPadで表示崩れが起きるため、15文字以降は省略
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }
      }
      // テーブルのオプション
      // マージン調整、フィルター部分のサイズを他のページより少なくする
      .table-options {
        margin-bottom: 12px;

        .filter {
          margin-right: 8px;
          width: 140px;
        }
      }
    }

    // 右側、メッセージリスト
    .message-list {
      min-width: 50%;
      max-width: 50%;
      overflow-y: auto;
      overflow-x: auto;
      border-left: solid 1px $border-darkgray;

      .message-list-title {
        @include title();
        border-bottom: solid 1px $border-lightgray;
        min-height: 35px;
      }
      .message-list-body {
        overflow-y: scroll;
        overflow-x: auto;
        // 縦幅の自動調整。画面全体の大きさから家族リストの高さ以外を減算する
        height: calc(100vh - 200px);
        position: relative;
        // 背景色
        background-color: $bg-message;

        .show-more-btn {
          margin: 10px;
          text-align: center;
        }

        .message {
          padding: 10px 0 10px 0;
          // botの発言
          .message-left {
            position: relative;
            display: inline-block;
            margin-bottom: 5px;
            max-width: 75%;
            clear: both;
            margin-left: 30px;
            max-width: 540px;
            // 発言本文
            .text {
              padding: 10px;
              border-radius: 20px;
              background-color: $bg-message-bot;
              margin: 0;
              margin-right: 80px;
              // LINEの吹き出しのように見せるために、CSSで図形を描画
              &::after {
                content: "";
                position: absolute;
                display: block;
                width: 0;
                height: 0;
                left: -10px;
                top: 10px;
                border-right: 20px solid $bg-message-bot;
                border-top: 10px solid transparent;
                border-bottom: 10px solid transparent;
              }
            }
            .pdf > .link {
              cursor: pointer;
            }
            // 日付部分
            .date {
              color: $date-font-color;
              text-align: left;
              font-size: 14px;
              font-weight: bold;
            }
            .buttons,
            .flex {
              background-color: $bg-message-bot;
            }
          }
          // 自分の発言
          .message-right {
            position: relative;
            margin-top: 5px;
            max-width: 75%;
            float: right;
            clear: both;
            margin-right: 30px;
            max-width: 540px;
            // 発言本文
            .text {
              padding: 10px;
              border-radius: 20px;
              background-color: $bg-message-mine;
              color: rgba(255, 255, 255, 1);
              margin: 0;
              margin-left: 80px;
              // LINEの吹き出しのように見せるために、CSSで図形を描画
              &::after {
                content: "";
                position: absolute;
                display: block;
                width: 0;
                height: 0;
                right: -10px;
                top: 10px;
                border-left: 20px solid $bg-message-mine;
                border-top: 10px solid transparent;
                border-bottom: 10px solid transparent;
              }
            }
            // 日付部分
            .date {
              color: $date-font-color;
              text-align: right;
              font-size: 14px;
              font-weight: bold;
            }
            .buttons,
            .flex {
              background-color: $bg-message-mine;
              color: rgba(255, 255, 255, 1);
            }
          }
          // LINE風に表示を行うため、vueがメッセージの情報を取得後、スクロールバーの位置を一番下に移動させている
          // vueがDOM要素を作成した後、img要素のsrc属性のURLにGETが走り、画像が取得される
          // 画像の大きさを固定しておかなかった場合、img要素は動的に高さが変わり、スクロールバーの長さが変わる
          // スクロールバーの長さが変わると、スクロール位置もずれてしまい、位置が一番下ではなくなってしまう
          // これを回避するため、画像を表示するdiv要素の高さおよびimg要素の高さを固定し、img要素の高さが動的に変わるのを防ぐ
          .image {
            // TODO 「ここで高さを固定しないと、問題が発生するため、高さ固定」とあるが、max-heightで問題がないか確認する
            // height: 320px;
            max-height: 320px;
            img {
              // 画像サイズは高さ固定
              height: 300px;
              max-width: 700px;
            }
          }
          .video {
            // TODO 「ここで高さを固定しないと、問題が発生するため、高さ固定」とあるが、max-heightで問題がないか確認する
            // height: 320px;
            max-height: 320px;
            video {
              // 動画サイズは高さ固定
              height: 300px;
              max-width: 700px;
            }
          }
          .buttons {
            padding: 10px;
            width: 300px;
            border-radius: 20px;
            .buttons-image {
              padding: 8px;
              text-align: center;
              // ここで高さを固定しないと、問題が発生するため、高さ固定
              height: 180px;
              img {
                // 画像サイズは固定
                max-height: 180px;
                max-width: 260px;
              }
            }
            .title {
              padding: 8px;
              font-weight: bold;
              font-size: 16px;
            }
            .contents {
              padding: 8px;
              font-size: 14px;
            }
            .link {
              padding: 8px;
              font-size: 14px;
              text-align: center;
              a {
                color: $font-key-color;
              }
            }
          }
          .flex-event {
            padding: 10px;
            width: 300px;
            border-radius: 20px;
            .flex-image {
              //padding: 8px;
              text-align: center;
              // ここで高さを固定しないと、問題が発生するため、高さ固定
              height: 180px;
              img {
                // 画像サイズは固定
                max-height: 180px;
                max-width: 280px;
              }
            }
            .sub-title {
              padding: 0 8px;
              font-size: 12px;
            }
            .title {
              padding: 8px;
              font-weight: bold;
              font-size: 16px;
            }
            .flex-option {
              padding: 0 8px;
              font-size: 14px;
              span {
                display: inline-block;
                width: 50px;
                font-weight: bold;
              }
            }
            .contents {
              padding: 0 8px;
              font-size: 14px;
            }
          }
          .flex-family-message-reply {
            padding: 10px;
            width: 300px;
            border-radius: 20px;
            .sub-title {
              padding-left: 8px;
              font-size: 12px;
            }
            .text {
              margin: 0;
              padding: 8px;
              font-size: 16px;
            }
            .notification-text {
              font-size: 12px;
            }
            .link {
              padding: 8px;
              font-size: 14px;
              text-align: center;
              a {
                color: $font-key-color;
              }
            }
          }
          .flex-send-message {
            padding: 10px;
            width: 300px;
            border-radius: 20px;
            .title {
              padding: 0 8px 8px 8px;
              font-weight: bold;
              font-size: 16px;
            }
            .sub-title {
              padding-left: 8px;
              font-size: 12px;
            }
            .text {
              margin: 0;
              padding: 8px;
              font-size: 16px;
            }
            .expiration-date {
              color: $date-font-color;
              font-size: 12px;
            }
            .expiration-text {
              color: $date-font-color;
              font-size: 12px;
            }
            .option-text {
              padding: 0 0 8px 8px;
              font-size: 12px;
              color: $errormessage-font-color;
            }
            .send-message-buttons {
              border-top: 2px;
              //border-top-color:

              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              justify-content: flex-start;
              align-items: stretch;
              align-content: flex-start;
              div {
                flex: 1;
                display: flex;
                justify-content: center;
                align-items: stretch;

                margin: 8px 12px 0 12px;
                // ボタン風の見た目にする
                border-radius: 0.25rem;
                background-color: $btn !important;
                color: $btn-font !important;
                font-size: 18px !important;
                height: 42px !important;
                padding: 2px 10px !important;

                span {
                  align-self: center;
                }
              }
            }
            .link {
              padding: 8px;
              font-size: 14px;
              text-align: center;
              a {
                color: $font-key-color;
              }
            }
          }
        }
      }
    }
  }
}
</style>
